// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SyAM","badges":"styles_badges__2nrp6"};